"use client";
import { ark } from "../factory.js";
import { useFieldContext } from "./use-field-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/field/field-input.tsx
var FieldInput = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useFieldContext()?.getInputProps(), props);
	return /* @__PURE__ */ jsx(ark.input, {
		...mergedProps,
		ref
	});
});
FieldInput.displayName = "FieldInput";
//#endregion
export { FieldInput };
